import { useEffect } from 'react'

const PIXEL_ID = '2832673310418578'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

export function useMetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return

    try {
      if (window.fbq) {
        try {
          window.fbq('track', 'PageView')
        } catch (e) {
          // silent fail in restricted environments
        }
        return
      }

      /* eslint-disable */
      !(function (f: any, b: any, e: string, v: string) {
        if (f.fbq) return
        const n: any = (f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments)
        })
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = '2.0'
        n.queue = []
        const t: any = b.createElement(e)
        t.async = !0
        // Catch errors from the loaded fbevents.js script in sandboxed/CORS contexts
        t.onerror = function () {
          /* silent fail */
        }
        t.src = v
        const s: any = b.getElementsByTagName(e)[0]
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s)
        } else {
          b.head.appendChild(t)
        }
      })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js',
      )
      /* eslint-enable */

      try {
        window.fbq('init', PIXEL_ID)
        window.fbq('track', 'PageView')
      } catch (e) {
        // silent fail
      }
    } catch (e) {
      // Pixel script failed to load (e.g. blocked in sandboxed preview iframe,
      // ad blockers, or CSP). Fail silently so the rest of the page works.
      // The pixel will still load correctly on the published production site.
      console.warn('Meta Pixel could not be initialized:', e)
    }
  }, [])
}
